/**
 * register with rcm if rcn defined
 */
if (typeof rcm !== 'undefined') {
    rcm.addAngularModule('relivConference');
}
/**
 * relivConference module
 */
angular.module(
    'relivConference',
    [
        'RcmJsLib',
        'rcmApiLib',
        'checkout',
        'ngRoute',
        'rcmSwitchUser',
        'app-ui-profile',
    ]
);

/**
 * jQuery
 */
angular.module('relivConference').service(
    'jQuery',
    function () {
        return jQuery;
    }
);
